// extracted by mini-css-extract-plugin
export default {"DownloadElement":"DownloadElement_DownloadElement__nSgzi","appStoreButton":"DownloadElement_appStoreButton__D9bwN"};